import { Box, Flex } from '@chakra-ui/layout';
import { Button } from '@chakra-ui/react';
import React from 'react';

import { Select } from 'packages/common-frontend/components/Select';
import { Typography } from 'packages/common-frontend/components/Typography';
import {
  WizardComponent,
  PartyType,
} from '~/core/routes/settings/implementations/create/ImplementationWizard';

const options: { value: PartyType; label: string }[] = [
  { value: 'borrower', label: 'Borrower' },
  { value: 'capitalProvider', label: 'Capital Provider' },
  // { value: 'lenderAdministrativeAgent', label: 'Lender, Administrative Agent' },
  // { value: 'administrativeAgent', label: 'Administrative Agent' },
  { value: 'servicer', label: 'Servicer' },
  { value: 'verificationAgent', label: 'Verification Agent' },
];

export const AssignParties: WizardComponent = ({
  selectedOrgs,
  setSelectedOrgs,
  previousStep,
  nextStep,
}) => {
  const canProceedToNextStep = selectedOrgs.every(
    (org) => org.type !== undefined,
  );

  return (
    <Box width="100%">
      <Box>
        <Typography variant="page-title">Assign Parties</Typography>
        <Typography variant="base-muted">
          Assign party roles to organizations in the facility.
        </Typography>
      </Box>
      <Box borderWidth="thin" borderRadius="8px" padding="2rem" my="2rem">
        <Box pb="0.4rem">
          <Typography variant="base" fontWeight="bold">
            Select Organizations
          </Typography>
        </Box>
        {selectedOrgs.map((org) => {
          const orgName = org.name;

          return (
            <Flex
              key={org.name}
              justify="space-between"
              py="0.2rem"
              align="center"
            >
              <Typography variant="base" fontWeight="bold">
                {orgName}
              </Typography>
              <Box width="50%">
                <Select
                  value={org.type}
                  placeholderLabel="Select Party Role"
                  onChange={(value) =>
                    setSelectedOrgs((prevOrgs) => {
                      const updatedOrgs = prevOrgs.map((prevOrg) =>
                        prevOrg.name === orgName
                          ? { ...prevOrg, type: value }
                          : prevOrg,
                      );

                      return updatedOrgs;
                    })
                  }
                  options={options}
                  width="100%"
                />
              </Box>
            </Flex>
          );
        })}
      </Box>
      <Flex justify="space-between">
        <Button onClick={previousStep}>Back</Button>
        <Button
          onClick={nextStep}
          isDisabled={!canProceedToNextStep}
          variant="primary"
          colorScheme="v2-aurora"
        >
          Next
        </Button>
      </Flex>
    </Box>
  );
};
